module.exports = __webpack_public_path__ + "img/Illustration-accueil.3a7a92d1.png";